import { render, staticRenderFns } from "./LightBoxImage.vue?vue&type=template&id=f433de72&scoped=true&"
import script from "./LightBoxImage.vue?vue&type=script&lang=js&"
export * from "./LightBoxImage.vue?vue&type=script&lang=js&"
import style0 from "./LightBoxImage.vue?vue&type=style&index=0&id=f433de72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f433de72",
  null
  
)

export default component.exports